import { Box } from '@mui/material';
import {
  SubscriptionGeneralTab,
  SubscriptionPaymentHistoryTab,
  SubscriptionPaymentMethodTab
} from 'modules/components/layer45';
import { ActivityDetailMultitabBase } from 'modules/components/layer50';



export type SubscriptionActivityMultitabProps = {};

export const FC = (props: SubscriptionActivityMultitabProps) => {
  return (
    <Box sx={{
      px: '2.5rem',
      py: '1.5rem'
    }}
    >

      <ActivityDetailMultitabBase.FC
        tabArray={[
          {
            label: 'General',
            value: 0,
            tab: (
              <Box sx={{
                mx: '-2.5rem',
                my: '-1.5rem'
              }}
              >
                <SubscriptionGeneralTab.FC />
              </Box>
            )
          },
          {
            label: 'Payment Method',
            value: 1,
            tab: (
              <SubscriptionPaymentMethodTab.FC />
            )
          },
          {
            label: 'Payment History',
            value: 2,
            tab: (
              <SubscriptionPaymentHistoryTab.FC />
            )
          }
        ]}
      />
    </Box>
  );
};
